import { render, staticRenderFns } from "./Island4.vue?vue&type=template&id=f265b9b8"
import script from "./Island4.vue?vue&type=script&lang=js"
export * from "./Island4.vue?vue&type=script&lang=js"
import style0 from "./Island4.vue?vue&type=style&index=0&id=f265b9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports